import React from 'react';
import HdDocLink from '../../../../../docs/components/doc-link/HdDocLink';
import { SelectionDestinationTypeHeaderType } from '../../interfaces/selectDestinationType';
import styles from './SelectDestinationTypeHeader.module.scss';

interface HeaderProps {
  docLink?: string;
  headerType: SelectionDestinationTypeHeaderType;
  destinationKeyword: string;
}

export default function SelectDestinationTypeHeader({
  docLink,
  headerType,
  destinationKeyword
}: HeaderProps) {
  return (
    <div className={`header-container ${styles.headerWrapper}`}>
      {headerType === SelectionDestinationTypeHeaderType.ADD_DESTINATION ? (
        <>
          {/* Global .header/.subheader, matching the source-type and
              pipeline-mode steps — MUI's h3 rendered visibly bolder. */}
          <div className='header'>Select {destinationKeyword} Type</div>

          <span className={`subheader ${styles.linkHolder}`}>
            A Destination is a data warehouse that stores all your data.{' '}
            {docLink ? (
              <HdDocLink
                docLink={docLink}
                section='select_destination_type'
                dataId='destination'
              />
            ) : null}
          </span>
        </>
      ) : null}

      {headerType === SelectionDestinationTypeHeaderType.SELECT_DESTINATION_TYPE ? (
        <>
          <div className='header'>Select {destinationKeyword} Type</div>

          <span className={`subheader ${styles.linkHolder}`}>
            Select the {destinationKeyword} Type to move your data.
          </span>
        </>
      ) : null}
    </div>
  );
}
